import { useEffect } from 'react';
import { useToast } from '../lib/toastContext';
import { registerErrorHandler } from '../lib/errorLib';

// Connects the module-level onError() to the MUI toast system.
// Must be rendered inside ToastProvider.
export default function ErrorHandlerConnector() {
  const { showError } = useToast();

  useEffect(() => {
    registerErrorHandler(showError);
  }, [showError]);

  return null;
}
